/*
  Fit Finder A/B test — sticky 50/50 traffic split.

  Runs only on /pages/fit-finder (the control page), before the finder
  section itself renders (see the fit-finder-variant-split section, ordered
  first in templates/page.finder.json). Assigns each visitor to v1_control
  or v2_challenger once, persists the assignment the same way as the visitor
  id (dongar-visitor.js), and redirects v2-assigned visitors to
  /pages/fit-finder-v2. Repeat visits reuse the stored assignment instead of
  re-rolling, so the same visitor keeps seeing the same variant even if they
  leave and come back on a later Amazon purchase.

  Fails open: if storage is unavailable, everyone falls through to the
  control page rather than looping or erroring.
*/
(function () {
  'use strict';

  try {
    var KEY = 'dongar_ff_variant', TS_KEY = 'dongar_ff_variant_ts';
    var MAX_AGE_MS = 90 * 24 * 60 * 60 * 1000;
    var CHALLENGER_PATH = '/pages/fit-finder-v2';

    var now = Date.now();
    var storedTs = parseInt(localStorage.getItem(TS_KEY) || '0', 10);
    var variant = localStorage.getItem(KEY);

    if (!variant || !storedTs || (now - storedTs) > MAX_AGE_MS) {
      variant = Math.random() < 0.5 ? 'v1_control' : 'v2_challenger';
      localStorage.setItem(KEY, variant);
      localStorage.setItem(TS_KEY, String(now));
    }

    if (variant === 'v2_challenger') {
      window.location.replace(CHALLENGER_PATH + (window.location.search || ''));
    }
  } catch (e) {
    /* storage blocked/unavailable — fall through, visitor sees control */
  }
})();
